import { toast } from "react-toastify";

export const renderError = error => {
    if(error?.code === 'ERR_CANCELED'){
        return;
    }

    if(!error.response){
        console.log(error);
        toast.error('Erro no servidor');
        return;
    }

    if(error.response?.status === 404){
        window.location.href = '/404';
        return;
    }

    if(error.response?.status === 413){
        toast.error('O arquivo enviado é muito grande.');
        return;
    }

    if(error.response?.data?.fields){
        Object.keys(error.response.data.fields).map(function(field) {
            error.response.data.fields[field].map(err => {
                toast.error(err);
            });
        });
        return;
    }

    if(error?.response?.data?.message){
        toast.error(error.response.data.message);
        return;
    }

    console.log(error);
    toast.error('Erro desconhecido');
    return;
}